import i18n from "../../../i8n";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";

const DonutChartGraph = ({
    data,
    colors = [],
    centerValue,
    centerLabel,
    height = 240,
    innerRadius = 55,
    outerRadius = 85,
}) => {
    const displayData = (Array.isArray(data) ? data : []).filter(
        (item) => Number(item.value) > 0
    );

    if (!displayData.length) {
        return (
            <div
                style={{
                    width: "100%",
                    height,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#777",
                    fontSize: "14px",
                }}
            >
                {i18n.t("ui.charts.noData")}
            </div>
        );
    }

    return (
        <div
            style={{
                width: "100%",
                height,
                position: "relative",
            }}
        >
            <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                    <Pie
                        data={displayData}
                        dataKey="value"
                        nameKey="name"
                        innerRadius={innerRadius}
                        outerRadius={outerRadius}
                        paddingAngle={3}
                        startAngle={90}
                        endAngle={-270}
                    >
                        {displayData.map((entry, index) => (
                            <Cell
                                key={`cell-${index}`}
                                fill={colors[index % colors.length]}
                            />
                        ))}
                    </Pie>
                    <Tooltip
                        formatter={(value, name) => [
                            `${Number(value).toFixed(2)}%`,
                            name,
                        ]}
                        contentStyle={{
                            backgroundColor: "#fff",
                            border: "none",
                            borderRadius: "8px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                            fontSize: "14px",
                        }}
                        labelStyle={{
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#333",
                        }}
                    />
                </PieChart>
            </ResponsiveContainer>
            <div
                style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    textAlign: "center",
                    pointerEvents: "none",
                }}
            >
                <div
                    style={{
                        fontSize: "26px",
                        fontWeight: 700,
                        color: "#0b6775",
                        lineHeight: 1.1,
                    }}
                >
                    {centerValue}
                </div>
                {centerLabel && (
                    <div
                        style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                        }}
                    >
                        {centerLabel}
                    </div>
                )}
            </div>

            <div
                style={{
                    position: "absolute",
                    bottom: "0",
                    left: "50%",
                    transform: "translateX(-50%)",
                    display: "flex",
                    gap: "16px",
                    justifyContent: "center",
                    pointerEvents: "none",
                }}
            >
                {displayData.map((entry, index) => (
                    <div
                        key={index}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            fontSize: "13px",
                            color: "#666",
                        }}
                    >
                        <span
                            style={{
                                width: "12px",
                                height: "12px",
                                borderRadius: "50%",
                                background: colors[index % colors.length],
                                flexShrink: 0,
                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                            }}
                        ></span>
                        {entry.name}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DonutChartGraph;
